import clsx from 'clsx';
import { FC, ReactNode } from 'react';

interface SectionProps {
  className?: string;
  children: ReactNode;
}

export const Section: FC<SectionProps> = ({ className, children }) => {
  const sectionClassName = clsx(className);
  return (
    <section data-testid="section-component" className={sectionClassName}>
      {children}
    </section>
  );
};
